/**
 * How "Open Gmail" opens the inbox: the Gmail app on a phone, a browser tab
 * elsewhere (and on a phone without the app).
 */
export type GmailOpen =
  | { kind: 'tab'; url: string }
  // Android Chrome opens the app, or `browser_fallback_url` when it is not installed.
  | { kind: 'navigate'; url: string }
  // iOS has no fallback built in: try the app scheme, then the web inbox if the page is still showing.
  | { kind: 'app-then-web'; appUrl: string; webUrl: string }

export function gmailWebUrl(email: string): string {
  return `https://mail.google.com/mail/u/?authuser=${encodeURIComponent(email)}`
}

export function planGmailOpen(userAgent: string, maxTouchPoints: number, email: string): GmailOpen {
  const webUrl = gmailWebUrl(email)
  if (/Android/i.test(userAgent)) {
    return {
      kind: 'navigate',
      url: `intent://#Intent;action=android.intent.action.MAIN;category=android.intent.category.LAUNCHER;package=com.google.android.gm;S.browser_fallback_url=${encodeURIComponent(webUrl)};end`,
    }
  }
  // iPadOS reports itself as a Mac; touch points tell them apart.
  if (/iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)) {
    return { kind: 'app-then-web', appUrl: 'googlegmail://', webUrl }
  }
  return { kind: 'tab', url: webUrl }
}
